// common/hooks/useTeamOfficialTypes.ts
//
// React Query hook for a sport's team-official roles (1 → "Manager", …).
// Static reference data, so cached with a 1h staleTime. Disabled until a sport
// id is known; callers render no role name until it lands.

import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '../config/queryKeys'
import {
  listTeamOfficialTypes,
  type TeamOfficialType,
} from '../services/types/listTeamOfficialTypes'

export type { TeamOfficialType }

// 1 hour — role types are static reference data.
const STALE_TIME = 60 * 60 * 1000

export const useTeamOfficialTypes = (
  sportId: string | null | undefined
): {
  teamOfficialTypes: TeamOfficialType[]
  loading: boolean
  error: Error | null
} => {
  const { data, isPending, error } = useQuery({
    queryKey: queryKeys.teamOfficialTypes.bySport(sportId),
    queryFn: () =>
      sportId ? listTeamOfficialTypes(sportId) : Promise.resolve([]),
    enabled: !!sportId,
    staleTime: STALE_TIME,
  })

  return {
    teamOfficialTypes: data ?? [],
    loading: isPending,
    error: (error as Error) ?? null,
  }
}
